import React from 'react';
import SectionComponent from "./SectionComponent";
import { IMG_NEW_BUILD } from "../../data/constructionServiceImages";

function NewBuild() {
  return (
    <SectionComponent
      images={IMG_NEW_BUILD}
      titles={{
        mainTitle: "New build construction",
        subTitle: "Residential and commercial new build delivery",
        sectionTitle1: "Groundworks & structure",
        sectionTitle2: "Envelope & weathertight",
        sectionTitle3: "Coordination & QA",
        sectionTitle4: "Project photography",
      }}
      descriptions={{
        sectionDescription1: "We deliver new build projects with clear sequencing from foundations through superstructure, coordinating structural packages and inspections with the design team.",
        sectionDescription2: "We manage envelope and weathertight milestones to protect follow-on trades, with documented checks at critical interfaces.",
        sectionDescription3: "Quality assurance is embedded in the programme: snagging, record drawings, and handover documentation structured for architects and clients.",
        imageAlt: "New build construction progress"
      }}
      galleryLink="/projects/new-build"
      seo={{
        title: "New build construction",
        description: "New build residential and commercial construction with programme control and architect coordination. MA Renovations."
      }}
    />
  )
}

export default NewBuild;
